@file:OptIn(InternalResourceApi::class)

package fichafacil.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/fichafacil.shared.generated.resources/"

@delegate:ResourceContentHash(-486_234_732)
internal val Res.drawable.app_logo: DrawableResource by lazy {
      DrawableResource("drawable:app_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/app_logo.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(379_089_144)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_560_389_856)
internal val Res.drawable.cragma_logo_blue: DrawableResource by lazy {
      DrawableResource("drawable:cragma_logo_blue", setOf(
        ResourceItem(setOf(), "${MD}drawable/cragma_logo_blue.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(46_536_874)
internal val Res.drawable.cragma_logo_white: DrawableResource by lazy {
      DrawableResource("drawable:cragma_logo_white", setOf(
        ResourceItem(setOf(), "${MD}drawable/cragma_logo_white.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_036_032_756)
internal val Res.drawable.ic_apple_logo: DrawableResource by lazy {
      DrawableResource("drawable:ic_apple_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_apple_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-850_827_948)
internal val Res.drawable.ic_google_logo: DrawableResource by lazy {
      DrawableResource("drawable:ic_google_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_google_logo.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("app_logo", Res.drawable.app_logo)
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("cragma_logo_blue", Res.drawable.cragma_logo_blue)
  map.put("cragma_logo_white", Res.drawable.cragma_logo_white)
  map.put("ic_apple_logo", Res.drawable.ic_apple_logo)
  map.put("ic_google_logo", Res.drawable.ic_google_logo)
}
